import React from 'react'
import { useFormikContext } from 'formik'

type ClearButtonProps = { resetValue?: Record<string, unknown> }

const ClearButton: React.FC<ClearButtonProps> = ({ resetValue }) => {
    const { resetForm, setValues } = useFormikContext()

    const handleFormReset = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        resetValue ? setValues(resetValue) : resetForm()
    }

    return <button className='button clear' onClick={handleFormReset}>Clear</button>
}

export default ClearButton
